// Set only on the AB-test (canary) deployment (see next.config.ts). NEXT_PUBLIC_
// so the value is identical in server-rendered HTML and in client bundles —
// components reached from client components (e.g. Icon.tsx) would otherwise
// resolve an empty prefix in the browser and mismatch the server-rendered HTML.
const rawPrefix = process.env.NEXT_PUBLIC_ASSET_PREFIX?.trim();

export const ASSET_PREFIX = rawPrefix ? rawPrefix : undefined;

// Only for asset paths Next.js doesn't already rewrite itself (metadata icons,
// next/script src, next/image src, CSS custom properties). _next/static and
// next/font output are rewritten by Next's own `assetPrefix` config already.
export const withAssetPrefix = (path: string): string =>
  ASSET_PREFIX ? `${ASSET_PREFIX}${path}` : path;
